<template>
    <div class="templete">
        <div class="search_box clearfix StockSearch">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="起始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <div class="reset fcolor" @click="reset">重置</div>
            <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
        </div>
        <div class="tableBox selectStockTable">
            <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getTableDelete="getTableDelete" @getTableEdit="getTableEdit"></tabletem>
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- 开发票 dialog START -->
        <el-dialog v-dialog-drag title="发票" :visible.sync="addDialogVisibleBill" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="add_billParams" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="发票抬头：">
                        <el-input v-model="add_billParams.title" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="发票名称：">
                        <el-input v-model="add_billParams.name" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="发票号码：">
                        <el-input v-model="add_billParams.code" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="发票金额：">
                        <el-input v-model="add_billParams.amount" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="销售单号：">
                        <el-input v-model="add_billParams.order_sn" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="add_billParams.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisibleBill=!addDialogVisibleBill">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addOrderBill">确定</el-button>
            </div>
        </el-dialog>
        <!-- 开发票 dialog END -->
    </div>
</template>
<script>
    import tabletem from '../../../components/table.vue'
    import pagination from '../../../components/pagination.vue'
    export default {
        props:["id",'type'],
        data(){
            return{
                types:this.type,
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                params:{
                    search:{
                        start_time:"",
                        end_time:"",
                        order_id:this.id,
                        purchase_id:this.id
                    },
                    per_page:50,
                    page:1
                },
                //发票 start
                add_billParams:{
                    id:"",
                    invoice_time:"",
                    title:"",
                    order_id:"",
                    name:"",
                    code:"",
                    amount:"",
                    remark:""
                },
                trading_time:"",
                addDialogVisibleBill:false,
                //发票 end
                start_time:"",
                end_time:"",
                last_page:1,
                total:0,
                list:[],
                tableCol:[	
                    {colName:"开票日期",colKey:"invoice_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"发票抬头",colKey:"title",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"发票名称",colKey:"name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"发票号码",colKey:"code",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"发票金额",colKey:"amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"经办人",colKey:"operator_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true}
                ]
            }
        },
        created(){
            this.getList()
        },
        methods:{
            //开发票
            addOrderBill(){
                this.$confirm('是否确认修改?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.add_billParams.invoice_time=this.formatTimeZero(this.trading_time)
                    this.postFunc("/erp/invoice.update",this.add_billParams,()=>{
                        this.tip("修改成功","success")
                        this.addDialogVisibleBill=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getTableDelete(id){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("/erp/invoice.delete",{id:id},()=>{
                        this.tip("删除成功","success")
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getTableEdit(id){
                this.list.forEach(item=>{
                    if(item.id==id){
                        this.add_billParams = JSON.parse(JSON.stringify(item))
                        this.trading_time = item.invoice_time;
                        // this.add_billParams.invoice_date = item.invoice_time;
                        // this.add_billParams.invoice_title = item.title;
                        this.addDialogVisibleBill = true;
                    }
                })
            },
            reset(){
                this.start_time="";
                this.end_time="";
                this.params={
                    search:{
                        start_time:"",
                        end_time:"",
                        order_id:this.id
                    },
                    per_page:50,
                    page:1
                },
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.search.start_time = this.formatTimeZero(this.start_time);
                this.params.search.end_time = this.formatTimeZero(this.end_time);
                this.tableLoading = true;
                let url = "";
                if(this.type == 1){
                    url = "/erp/invoice.list";
                }else if(this.type == 2){
                    url = "/erp/cloud.purchase.invoice.list";
                }
                this.postFunc(url,this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.list;
                    this.list.forEach((item,index)=>{
                        item.isEdit = true;
                        item.isDelete = true;
                        this.list[index].invoice_time = this.formatTime(item.invoice_time*1000)
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "id":function(val){
                this.params.search.order_id = val;
                this.params.search.purchase_id = val;
                this.getList()
            },
            'addDialogVisibleBill':function(val){
                if(!val){
                    this.add_billParams=this.resetJson(this.add_billParams)
                }
            },
            "type":function(val){
                this.types = val;
            }
        }
    }
</script>
<style scoped>
    .pageAssembly .pageSize{margin-top:3px;}
    .totalBox{float: left;}
    .totalBox .total{float: left;font-size: 12px;line-height: 33px;margin-right:15px;}
    .btnBox{float: right;}
</style>